module.exports = __webpack_public_path__ + "img/father.be5030ca.webp";